(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-soccer/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-soccer/assets/javascripts/init-box.js'); var svs = svs || {};

(function(svs) {
  svs.themes = svs.themes || {};
  svs.themes.sport_soccer = svs.themes.sport_soccer || {};
  svs.themes.sport_soccer.initStatus = function(data) {
    setTimeout(function() {
      var $init = $('[data-init-id="' + data.matchId + '"] .js-live-clock');

      if ($init.length) {
        _.each($init, function(init) {
          $(init).replaceWith(svs.themes.sport_soccer.initStatusStart(data));
        });
      }
    }, 60000);

    var $init = $('[data-init-id="' + data.matchId + '"] .js-live-clock');
    if ($init.length) {
      _.each($init, function(init) {
        $(init).replaceWith(
          svs.themes.sport_soccer.initStatusStart(data, true)
        );
      });
    }
  };

  svs.themes.sport_soccer.hasMatchMinutes = function() {
    return true;
  };

  svs.themes.sport_soccer.initStatusStart = function(data, noclock) {
    var diff = 0;

    if (svs.themes.sport_soccer.isLive(data.status.id)) {
      if (data.status.id === 15) {
        return '<div class="brick match-status brick-active f-condensed align-center">HT</div>';
      }

      if (
        data.status.id === 16 ||
        data.status.id === 17 ||
        data.status.id === 18
      ) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      }

      if (data.status.id === 19) {
        return '<div class="brick match-status brick-active f-condensed align-center">ÖT</div>';
      }

      if (data.status.id === 22) {
        return '<div class="brick match-status brick-active f-condensed align-center">STR</div>';
      }

      if (data.status.realTime) {
        diff = Math.ceil(
          Math.abs(
            svs.themes.getDifferenceBetweenDates(
              data.status.realTime,
              new Date().setSeconds(0, 0),
              'minutes',
              false
            )
          )
        );
      }

      if (data.status.id === 6 && diff > 45) {
        return '<div class="brick match-status brick-active f-condensed align-center">45+</div>';
      }

      if (data.status.id === 7) {
        diff += 45;
        if (diff > 90) {
          return '<div class="brick match-status brick-active f-condensed align-center">90+</div>';
        }
      }
      if (data.status.id === 20) {
        diff += 90;
        if (diff > 105) {
          return '<div class="brick match-status brick-active f-condensed align-center">105+</div>';
        }
      }
      if (data.status.id === 21) {
        diff += 105;
        if (diff > 120) {
          return '<div class="brick match-status brick-active f-condensed align-center">120+</div>';
        }
      }

      if (diff >= 0) {
        data.status.minutes = diff;
      } else {
        data.status.minutes = 1;
      }

      if (!noclock) {
        svs.themes.sport_soccer.initStatus(data);
      }

      return (
        '<div data-init-time-status="' +
        data.timeId +
        '" class="brick js-live-clock match-status brick-active f-condensed align-center">' +
        data.status.minutes +
        "'</div>"
      );
    } else if (svs.themes.sport_soccer.isEnded(data.status.id)) {
      if (data.status.id === 32) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">ÖT</div>';
      }
      if (data.status.id === 33) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">STR</div>';
      }
      return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">FT</div>';
    } else if (data.startTime) {
      return (
        '<div class="brick match-status brick-border f-condensed align-center">' +
        svs.themes.formatTime(data.startTime) +
        '</div>'
      );
    }

    return '';
  };
})(svs);

 })(window);